import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import Reveal from "./Reveal";

export default function FaqSection({ faqs }) {
  return (
    <section id="sss" data-testid="faq-section" className="relative py-28 bg-[#070A12]">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="text-center mb-14">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-cyan-400">Sıkça Sorulan Sorular</span>
            <h2 className="font-display font-700 text-3xl md:text-4xl mt-4 text-white tracking-tight">
              Merak Ettiklerin
            </h2>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={faq.id || i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl border border-white/[0.07] bg-[#0A0E17] px-6 data-[state=open]:border-cyan-400/30 transition-colors"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left text-sm font-semibold text-white hover:text-cyan-200 hover:no-underline py-5"
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="text-sm text-[#A0ABC0] leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
